import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React from 'react';
import {useTranslation} from 'react-i18next';
import '../../style/ConfirmationDialog.less';
import Dialog from './Dialog';

export default function ConfirmationDialog(props) {
    const [t] = useTranslation();

    return (
        <Dialog open={props.open} title={props.title} footer={
            <>
                {
                    props.cancel &&
                    <button
                        onClick={props.cancel}
                        type="button"
                        className="btn btn-transparent-primary">
                        <FontAwesomeIcon icon="times" className="mr-2"/>
                        {props.cancelLabel ? props.cancelLabel : t('Button.CANCEL')}
                    </button>
                }
                <button
                    onClick={props.accept}
                    type="button"
                    className="btn btn-primary">
                    <FontAwesomeIcon icon="check" className="mr-2"/>
                    {props.acceptLabel ? props.acceptLabel : t('Button.OK')}
                </button>
            </>
        }
        >
            {props.description}
        </Dialog>
    );
}
